export const TotalScheduledDuration = ({
    millisecondsToHuman,
    item
}) => {
    return (
        <div className="rounded px-2 py-1 mt-2" style={{ background: "#FFFFFF0A" }}>
            <span className="text-white d-flex justify-content-between" style={{ fontSize: "10px"}}>
                <span style={{ color: "#999999" }}>
                    Total scheduled
                </span>
                <span>
                    {millisecondsToHuman(item?.scheduleItems?.reduce((total, data) => total + (data?.totalDuration || 0), 0))}
                </span>
            </span>
        </div>
    )
}